import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {injectIntl} from "react-intl"
import {Link, useNavigate} from 'react-router-dom';
import {pagesNav, pagesCompanyNav, pagesAccNav} from "../../../utils/nav_company";
import Slide from '@mui/material/Slide';
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import platformConfig from '../../../config/config';
import {track} from "../../../redux/actions/Ref";
import useHasPermissionForRoute from '../../../utils/useHasPermissionForRoute';
import useHasPermissionForAction from '../../../utils/useHasPermissionForAction';

const Dashboard = ({intl}) => {
    const navigate = useNavigate();
    const [showMain, setShowMain] = React.useState(true);
    const [showSub, setShowSub] = React.useState(false);
    const [currentSubs, setCurrentSubs] = React.useState([]);
    const {contact} = useSelector(({company}) => company)
    const urlParams1 = new URLSearchParams(window.location.search);
    const tab1 = urlParams1.get('tab')
    const {name,disabledPages} = platformConfig;
    const dispatch = useDispatch()
    const {token, user} = useSelector(({auth}) => auth)
    const permissions = useHasPermissionForRoute();
    const hasCompanyInfo = useHasPermissionForAction("access-update-company-information-company");
    const hasViewInvoices = useHasPermissionForAction("view-all-invoices");
    const hasManageTeams = useHasPermissionForAction("manage-teams");
    const hasViewCollab = useHasPermissionForAction("view-colleagues");
    const hasEmployerBrand = useHasPermissionForAction("access-employer-brand");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab')
        if (tab == 'null' || tab == undefined) {
            setTimeout(function() {
                setShowMain(true)
                setShowSub(false)
            }, 200)
        }

        if (tab == 'recruitment') {
            setShowMain(false)
            setShowSub(true)
            setCurrentSubs(pagesNav[0].subs)
        }
        if (tab == 'portage') {
            setShowMain(false)
            setShowSub(true)
            setCurrentSubs(pagesNav[1].subs)
        }
        if (tab == 'parainage') {
            setShowMain(false)
            setShowSub(true)
            setCurrentSubs(pagesNav[2].subs)
        }
        if (tab == 'account') {
            setShowMain(false)
            setShowSub(true)
            setCurrentSubs(pagesAccNav[0].subs)
        }
    },[tab1])


    const getAccessibleNavItems = (pagesNav, permissions) => {
        return pagesNav.filter((nav) => {
            if (!nav.subs || nav.subs.length === 0) return true;

            const accessibleSubs = nav.subs.filter((sub) => {
            const required = sub.requiredPermission;

            if (!required) return true;

            return required.some((permRequired) =>
                permissions.some((perm) => perm.name === permRequired)
            );
            });

            return accessibleSubs.length > 0;
        });
    };

    const accessibleNavItems = getAccessibleNavItems(pagesNav, permissions);
    const accessibleCompanyNavItems = getAccessibleNavItems(pagesCompanyNav, permissions);

    const renderOptions = (options) => {
        let render = (
            <div className={'flex flex-col justify-left'}>
                {options.map((option, index) => (
                    <div key={index} className='text-center'>
                        {/* <i className={'fa fa-check text-blue-600 mr-2'}></i>  */}
                        {intl.formatMessage({id: option},{name})}
                    </div>
                ))}
            </div>
        )

        return render;
    }

    useEffect(() => {
        dispatch(track(token, 400))
    },[])

    const renderSubs = () => {
        const filteredSubs = currentSubs.filter((sub) => {
            const required = sub.requiredPermission;

            if (!required) return true;

            return required.some((permRequired) =>
                permissions.some((perm) => perm.name === permRequired)
            );
        });
    
        const layoutClass =
            filteredSubs?.length === 6 ? "md:grid-cols-2 xl:grid-cols-3" :
            filteredSubs?.length === 5 ? "md:grid-cols-2 xl:grid-cols-5" :
            filteredSubs?.length === 4 ? "md:grid-cols-2 xl:grid-cols-4" :
            filteredSubs?.length === 3 ? "md:grid-cols-2 xl:grid-cols-3" :
            filteredSubs?.length === 2 ? "md:grid-cols-2 xl:grid-cols-2" :
            "md:grid-cols-4";
    
        return (
            <div className={"flex flex-col"}>
                <div className={`flex flex-col space-y-4 md:space-y-0 md:grid ${layoutClass} gap-y-4 gap-x-8`}>
                    {filteredSubs.map((nav, index) => (
                        <div
                            key={index}
                            onClick={() => navigate(nav.path)}
                            className="shadow-xxl p-6 rounded-4xl flex flex-col space-y-6 items-center flex-1 transition duration-300 ease-in-out hover:shadow-2xl hover:bg-gray-100 cursor-pointer hover:scale-105"
                        >
                            <div className="text-lg font-bold text-secondary text-center">
                                {intl.formatMessage({ id: nav.name })}
                            </div>
                            <i className={`${nav.icon} text-blue-600 text-5xl`}></i>
                            {renderOptions(nav.options)}
                            <button
                                className="bg-secondary py-2 px-6 rounded-full text-white"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(nav.path);
                                }}
                            >
                                {intl.formatMessage({ id: nav.button_name })}
                            </button>
                        </div>
                    ))}
                </div>
    
                <div className="flex items-center justify-center">
                    <button
                        className="bg-secondary py-2 px-6 rounded-full text-white mt-6"
                        onClick={() => toggle(pagesNav[0].subs)}
                    >
                        <i className="fa-solid fa-arrow-left mr-4"></i> {intl.formatMessage({ id: "back" })}
                    </button>
                </div>
            </div>
        );
    };
    

    const renderAdminNav = () => {
        let render = (
            <React.Fragment>
                {accessibleCompanyNavItems.map((nav, index) => (
                    <div 
                        onClick={() => {
                            toggle(nav.subs)
                        }} 
                        key={index}
                         className={'shadow-xxl p-6 rounded-4xl flex flex-col space-y-4 items-center justify-between flex-1 transition duration-300 ease-in-out hover:shadow-2xl hover:bg-gray-100 cursor-pointer hover:scale-105'}>
                        <div className={'text-lg font-bold text-secondary text-center'}>
                            {intl.formatMessage({id: nav.name})}
                        </div>
                        <i className={nav.icon + " text-blue-600 text-5xl"}></i>
                        {renderOptions(nav.options)}
                        <button className={'bg-secondary py-2 px-6 rounded-full text-white'} onClick={() => {
                            toggle(nav.subs)
                        }}>
                            {intl.formatMessage({id: 'acceder'})} 
                        </button>
                    </div>
                ))}
            </React.Fragment>
        )

        return render;
    }

    const toggle = (subs) => {
        setCurrentSubs(subs)

        if (!showSub) {
            setTimeout(function() {
                setShowSub(!showSub)
            }, 200)
        } else {
            setShowSub(!showSub)
        }

        if (!showMain) {
            setTimeout(function() {
                setShowMain(!showMain)
            }, 200)
        } else {
            setShowMain(!showMain)
        }

    }

    const [activeIndex, setActiveIndex] = useState(null); 

    const toggleBackground = (index, subs) => {
        setActiveIndex(index); 
        toggle(subs); 
      };



    return (
        <div className={'p-6 min-h-screen_custom'}>
            <div className={'flex flex-col flex-grow'}>
                <div className="flex space-x-4 justify-center items-center relative mb-6">
                    <h1 className="xl:w-1/3 py-3 px-6 rounded-full shadow-xxl font-sans font-semibold text-secondary xl:text-lg text-center">
                        {intl.formatMessage({id: 'what.you.want.to.do'})} 
                    </h1>
                </div>

                <Slide direction="left" in={showSub} mountOnEnter unmountOnExit>
                    {renderSubs()}
                </Slide>
                <Slide direction="right" in={showMain} mountOnEnter unmountOnExit>
                    <div className={"grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"}>
                    {accessibleNavItems
                        .filter((nav) => !disabledPages.includes(nav.name))
                        .map((nav, index) => (
                            <div 
                                key={index} 
                                onClick={() => toggleBackground(index, nav.subs)} 
                                className={`shadow-xxl p-6 rounded-4xl cursor-pointer flex flex-col space-y-9 3xl:p-10 items-center justify-between flex-1 
                                    ${activeIndex === index ? 'bg-blue-100' : 'bg-white'} transition duration-300 ease-in-out hover:shadow-2xl hover:bg-gray-100 hover:scale-105`}
                            >
                                <div className={'text-lg font-bold text-secondary text-center'}>
                                    {intl.formatMessage({id: nav.name})}
                                </div>
                                <i className={ nav.icon + " text-blue-600 text-5xl"}></i>
                                {renderOptions(nav.options)}
                                <button
                                    className={'bg-secondary py-2 px-6 rounded-full text-white'}
                                    onClick={() => toggle(nav.subs)}
                                >
                                    {intl.formatMessage({id: 'acceder'})}
                                </button>
                            </div>
                    ))}
                    {hasCompanyInfo || hasManageTeams || hasViewInvoices || hasViewCollab || hasEmployerBrand ? renderAdminNav() : null}
                    {/* {pagesAccNav.map((nav, index) => (
                        <div key={index} className={'shadow-xxl p-6 rounded-4xl flex flex-col space-y-4 items-center justify-between flex-1'}>
                            <div className={'text-lg font-bold text-secondary text-center'}>
                                {intl.formatMessage({id: nav.name})}
                            </div>
                            <i className={ nav.icon + " text-blue-600 text-5xl"}></i>
                            {renderOptions(nav.options)}
                            <button className={'bg-secondary py-2 px-6 rounded-full text-white'} onClick={() => {
                                toggle(nav.subs)
                            }}>
                                {intl.formatMessage({id: 'enter'})}
                            </button>
                        </div>
                    ))} */}
                </div>
                </Slide>
            </div>
        </div>
    )
}

export default injectIntl(Dashboard)
